import { cn } from '@/lib/utils';

interface ReportsListSkeletonProps {
  pulse?: boolean;
}
export const ReportsListSkeleton = ({
  pulse = true,
}: ReportsListSkeletonProps) => {
  return (
    <div className="relative flex w-full flex-col gap-3 overflow-hidden pb-3 md:pb-4">
      <div
        className={cn(
          'flex h-fit w-full flex-col justify-start gap-2 rounded-lg border bg-gray-100 px-5 py-4',
          pulse && 'animate-pulse',
        )}>
        <div className="h-6 w-64 rounded-md bg-gray-200" />
        <div className="h-4 w-32 rounded-md bg-gray-200" />
      </div>
      <div
        className={cn(
          'flex h-fit w-full flex-col justify-start gap-2 rounded-lg border bg-gray-100 px-5 py-4',
          pulse && 'animate-pulse',
        )}>
        <div className="h-6 w-64 rounded-md bg-gray-200" />
        <div className="h-4 w-32 rounded-md bg-gray-200" />
      </div>
      <div
        className={cn(
          'flex h-fit w-full flex-col justify-start gap-2 rounded-lg border bg-gray-100 px-5 py-4',
          pulse && 'animate-pulse',
        )}>
        <div className="h-6 w-64 rounded-md bg-gray-200" />
        <div className="h-4 w-32 rounded-md bg-gray-200" />
      </div>
      <div className="absolute inset-0 bg-linear-to-b from-transparent to-white" />
    </div>
  );
};
